<template>
  <v-container
    v-if="!isProd"
    grid-list-md
    text-xs-center
  >
    <s-all-page />
    <s-app-icon />
  </v-container>
  <v-container
    v-else-if="$config.isGaWeb"
    grid-list-md
    text-xs-center
  />
  <v-container
    v-else-if="$config.isApp || $config.isPwa"
    grid-list-md
    text-xs-center
  >
    <s-app-icon />
  </v-container>
</template>

<script>
import SAllPage from '@/components/SAllPage'
import SAppIcon from '@/components/SAppIcon'

export default {
  components: {
    SAllPage,
    SAppIcon
  },
  data: function () {
    return {
      isProd: process.env.NODE_ENV === 'production',
      isAppOrPwa: this.$config.isApp || this.$config.isPwa
    }
  }
}
</script>
